import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, auth } from './financeApi';

export const useParentPayStatus = (token) => {
  const [data, setData] = useState({ status: {}, receipts: new Set() });
  useEffect(() => {
    if (!token) return;
    Promise.all([
      axios.get(`${API_URL}/parent/payment-status`, auth(token)),
      axios.get(`${API_URL}/parent/receipts`, auth(token)),
    ])
      .then(([s, r]) => setData({
        status: Object.fromEntries(s.data.map((x) => [x.kid_id, x.status])),
        receipts: new Set(r.data.map((x) => x.kid_id)),
      }))
      .catch(() => setData({ status: {}, receipts: new Set() }));
  }, [token]);
  return data;
};
